import EmailChangedPage from '~/widgets/my-account/EmailChangedPage.vue'

const epaper = {
  landingPage: {
    heading: {
      1: 'my life jetzt noch einfacher erleben',
      2: 'Jetzt einfach abonnieren',
      3: 'Oder in Ihrer Apotheke vor Ort erhalten',
      4: 'Jetzt my life-Apotheke in der Nähe finden',
      5: 'Jetzt aktuelle Ausgaben sichern!',
    },
    iconBlock: {
      1: 'Immer und überall top informiert über aktuelle Gesundheitsthemen',
      2: 'Gut für die Umwelt - indem Sie E-Paper lesen, sparen Sie Papier!',
      3: 'Kompetenter Gesundheits-journalismus in “Apotheken-Qualität”',
    },
    cardBlock: {
      user: {
        1: 'Schließen Sie das kostenlose E-Paper Abonnement ab.',
        2: 'Loggen Sie sich mit Ihren IhreApotheken-Kundendaten ein.',
        3: 'Erhalten Sie regelmäßig das my life E-Paper per E-Mail und rein ins Lesevergnügen!',
      },
      guest: {
        1: 'Legen Sie ein IhreApotheken.de-Konto an.',
        2: 'Aktivieren Sie das kostenlose Abonnement in Ihrem Kundenkonto.',
        3: 'Erhalten Sie zweimal pro Monat die neuste Ausgabe der my life als E-Paper per E-Mail.',
      },
    },
    paragraph: {
      1: 'Für alle, die sich immer und überall über Gesundheit & Medizin, Wellness & Beauty, Achtsamkeit, alternative Heilmethoden, Essen & Trinken, Wohnen & Garten sowie Lifestyle & Reisen auf dem Laufenden halten wollen, ist die my life jetzt auch als kostenloses, digitales E-Paper verfügbar.',
      2: 'Neue Ausgaben des E-Papers erscheinen jeweils zum 2. und 16. eines jeden Monats.',
      3: 'Sie erhalten das my life Magazin in Ihrer Apotheke in der Nähe kostenlos als Print-Magazin. Das Print-Magazin erscheint jeweils zum 1. und 15. eines jeden Monats in Ihrer Apotheke.',
      4: 'Finden Sie hier das my life-Magazin in Ihrer Apotheke vor Ort.',
    },
    button: {
      subscribe: 'Jetzt abonnieren',
      toPharmacy: 'Zur Apotheke',
    },
  },
  magazinePage: {
    heading: 'my life E-Paper',
    paragraph: 'Lesen Sie alle my life Magazine jetzt auch digital - von überall und jederzeit. Mit Klick auf die Magazin-Vorschau öffnet sich das E-Paper.',
    latestTitle: 'Aktuelle Ausgabe',
    editionOf: 'Ausgabe vom',
    archiveTitle: 'Alle Magazine',
    button: 'Jetzt lesen',
    allMagazines: 'Alle Magazine',
    loadMore: 'Mehr laden',
    emailNotificationHeading: 'E-Mail-Benachrichtigung',
    emailNotificationText: 'Ich möchte per E-Mail über die neue Ausgabe my life Magazin informiert werden. Meine Anmeldung ist freiwillig und kann jederzeit widerrufen werden.',
    emailNotificationCheckbox: 'E-Mail-Benachrichtigung',
    emailNotificationSubtext: 'Hier finden Sie unsere',
    privacyPolicy: 'Datenschutzerklärung',
  },
  subscribeBlock: {
    heading: 'E-Paper abonnieren',
    paragraph: 'Sie erhalten die <strong>kostenlosen</strong> E-Paper jeweils zum 2. und 16. eines jeden Monats über einen Link, den wir Ihnen per E-Mail zusenden.',
    list: {
      1: 'Aktuelle und relevante Gesundheitsthemen jederzeit und überall verfügbar',
      2: 'Tolle Vorteilsangebote für Leser',
      3: '<strong>Kostenlos</strong> in Ihrer Apotheke und online',
    },
    policy: {
      termsOfUse: 'Nutzungsbedingungen',
      privacyPolicy: 'Datenschutzbestimmungen',
      1: 'Die',
      2: 'und',
      3: 'habe ich zur Kenntnis genommen und bin mit ihrer Geltung einverstanden.*',
    },
    pleaseFill: '* Bitte füllen Sie die Pflichtfelder aus',
    button: 'Kostenlos abonnieren',
  },
  successPage: {
    subscribe: {
      heading: 'Abonnement abgeschlossen',
      alertText: 'Sie haben Ihr my life E-Paper Abonnement erfolgreich abgeschlossen. Sie erhalten nun regelmäßig das my life E-Paper per E-Mail.',
      button: {
        toMagazine: 'Zu den Magazinen',
        toMyAccount: 'Zum Kundenkonto',
      },
    },
    epaperRegister: {
      heading: 'Registrierung & Abonnement abgeschlossen',
      alertText: 'Sie haben erfolgreich Ihr IhreApotheken.de-Kundenkonto angelegt und das my life E-Paper-Abonnement abgeschlossen. Eine E-Mail wurde an {email} gesendet. Diese enthält einen Link, den Sie anklicken müssen, um Ihr Benutzerkonto zu bestätigen.',
    },
    register: {
      heading: 'Vielen Dank für Ihre Registrierung',
      alertText: 'Eine E-Mail wurde an {email} gesendet. Diese enthält einen Link, den Sie anklicken müssen, um ihr Benutzerkonto zu bestätigen.',
      button: 'Zur Startseite',
    },
    unsubscribe: {
      heading: 'Ihr my life E-Paper Abonnement wurde gekündigt',
      toHomepage: 'Zur Startseite',
      manageSubscription: 'Abonnement verwalten',
    },
  },
  authentication: {
    description: 'Lesen Sie alle my life Magazine jetzt auch digital - von überall und jederzeit. Loggen Sie sich einfach mit Ihren IhreApotheken.de-Kundendaten ein und rein ins Lesevergnügen!',
    alert: {
      1: 'Um die my life E-Paper lesen zu können und um Ihr Abonnement zu verwalten,  wird ein IhreApotheken-Kundenkonto benötigt. Sie haben schon ein Konto?',
      2: 'Anmelden',
    },
    checkbox: 'Abonnieren Sie kostenlos die {strongText} als E-Paper. So bleiben Sie jederzeit und überall informiert zu allen relevanten Gesundheitsthemen. Ihre Anmeldung ist freiwillig und kann jederzeit widerrufen werden.',
    myLife: 'myLife',
  },
}
export default epaper
